// extracted by mini-css-extract-plugin
export default {"content":"Content_content__NL6OY","form":"Content_form__DLAze","contacts":"Content_contacts__0WKOk","card":"Content_card__VRujG","mes":"Content_mes__sAUDd"};